import {
    Alert,
    Button,
    Col,
    Form,
    InputNumber,
    Modal,
    Row,
    Table,
    Select,
    Descriptions,
    Upload,
    DatePicker,
} from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { PlusOutlined, UploadOutlined, DeleteOutlined, FileExcelOutlined } from '@ant-design/icons';
import { apiCall } from '../../API/RestApi';
import Search from 'antd/es/input/Search';
import { modalError } from '../../Component/Modal/ModalLayout';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { exportStockOutExcel, handleDownloadTemplate } from './export/ExportOutletStockExcel';
import dayjs from 'dayjs';


function OutletStock() {
    const token = useSelector((state) => state.user.token);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isModal, setIsModal] = useState(false);
    const [dataModal, setDataModal] = useState(null);
    const [search, setSearch] = useState('');
    const [page, setPage] = useState({ pagination: { current: 1, pageSize: 10 } });
    const [form] = Form.useForm();
    const [isAlert, setIsAlert] = useState(false);
    const [textAlert, setTextAlert] = useState('');
    const [outletOptions, setOutletOptions] = useState([]);
    const [variantOptions, setVariantOptions] = useState([]);
    const [variantMap, setVariantMap] = useState({});
    const [stockOutDetail, setStockOutDetail] = useState([]);
    const [stockOutModal, setStockOutModal] = useState(false);
    const [startDate, setStartDate] = useState(dayjs());
    const [endDate, setEndDate] = useState(dayjs());
    const [isExportModalOpen, setIsExportModalOpen] = useState(false);
    const [isImportModalOpen, setIsImportModalOpen] = useState(false);


    const titlePage = 'Stok Outlet';

    const columns = [
        {
            title: 'No',
            render: (_, __, index) => (page.pagination.current - 1) * page.pagination.pageSize + index + 1,
        },
        { title: 'Nama Outlet', dataIndex: 'outlet_name' },
        { title: 'Kode Outlet', dataIndex: 'outlet_code' },
        { title: 'Gudang', dataIndex: 'warehouse_name' },
        {
            title: 'Aksi',
            render: (_, record) => (
                <>
                    <Button type="default" onClick={() => openModal('detail', record)} style={{ marginRight: 8 }}>Detail</Button>
                    <Button type="primary" onClick={() => openModal('edit', record)} style={{ marginRight: 8 }}>Ubah</Button>
                    <Button type="primary" danger icon={<DeleteOutlined />} onClick={() => handleDelete(record.outlet_id)}>Hapus</Button>
                </>
            ),
        },
    ];

    useEffect(() => {
        getApi("GET", `/outletstock?search=${search}&page=${page.pagination.current}`, 'outletstock');
        getApi("GET", `/outlet?nopage=true`, 'outlet');
        getApi("GET", `/selectproduct`, 'variant');
    }, [JSON.stringify(page), search, isAlert]);

    const getApi = (method, url, type) => {
        setLoading(true);
        apiCall({ method, url, data: { headers: { Authorization: 'Bearer ' + token } } })
            .then((res) => {
                if (res.status === 200) {
                    if (type === 'outletstock') {
                        setData(res.data.rows);
                        setPage(prev => ({ ...prev, pagination: { ...prev.pagination, total: res.data.count } }));
                    } else if (type === 'outlet') {
                        setOutletOptions(res.data.map(o => ({ label: o.outlet_name, value: o.outlet_id })));
                    } else if (type === 'variant') {
                        const variantList = [];
                        const variantMapTemp = {};
                        res.data.rows?.forEach(product => {
                            product.variant_products?.forEach(variant => {
                                const label = (
                                    <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                                        <b>{product.product_name}</b><br />
                                        <small>{variant.variant_name || variant.SKU}</small>
                                    </div>
                                );
                                variantList.push({ label, value: parseInt(variant.variant_product_id) });
                                variantMapTemp[variant.variant_product_id] = `${product.product_name} - ${variant.variant_name || variant.SKU}`;
                            });
                        });
                        setVariantOptions(variantList);
                        setVariantMap(variantMapTemp);
                    }
                }
                setLoading(false);
            })
            .catch(() => setLoading(false));
    };

    const handleDelete = (id) => {
        Modal.confirm({
            title: 'Hapus data ini?',
            onOk: () => {
                setLoading(true);
                apiCall({ method: 'DELETE', url: `/outletstock/${id}`, data: { headers: { Authorization: 'Bearer ' + token } } })
                    .then((res) => {
                        if (res.status === 200) {
                            setIsAlert(true);
                            setTextAlert('Data berhasil dihapus');
                        }
                        setLoading(false);
                    })
                    .catch(() => setLoading(false));
            },
        });
    };


    const postApi = (method, values) => {
        setLoading(true);
        setIsAlert(false);
        const url = dataModal ? `/outletstock/${dataModal.outlet_id}` : '/outletstock';

        const payload = {
            outlet_id: values.outlet_id,
            product_variant: values.product_variant,
        };

        apiCall({
            method,
            url,
            data: {
                data: payload,
                headers: { Authorization: 'Bearer ' + token },
            },
        })
            .then((res) => {
                if (res.status === 200) {
                    setTextAlert(res.message);
                    setIsAlert(true);
                    closeModal();
                } else {
                    modalError(res.message);
                }
                setLoading(false);
            })
            .catch(() => setLoading(false));
    };

    const openModal = (type, record) => {
        if (type === 'edit' || type === 'detail') {
            setDataModal({ ...record, mode: type });
            form.setFieldsValue({
                outlet_id: record.outlet_id,
                product_variant: record.outlet_stocks?.map(s => ({
                    variant_product_id: parseInt(s.variant_product_id),
                    stock: parseInt(s.stock),
                })) || [],
            });
        } else {
            setDataModal(null);
            form.resetFields();
        }
        setIsModal(true);
    };

    const openStockOutModal = (outlet_stock_outs = []) => {
        setStockOutDetail(outlet_stock_outs);
        setStockOutModal(true);
    };

    const onFinish = (values) => {
        postApi(dataModal?.mode === 'edit' ? 'PUT' : 'POST', values);
    };

    const closeModal = () => {
        setIsModal(false);
        setDataModal(null);
        form.resetFields();
    };

    const handleTableChange = (pagination) => {
        setPage({ pagination });
    };

    const handleExportStockOut = async () => {
        exportStockOutExcel(token, startDate, endDate);
        setIsExportModalOpen(false);
    };


    const handleImportExcel = async (file) => {
        const formData = new FormData();
        formData.append('file', file);

        setLoading(true);
        try {
            const response = await apiCall({
                method: 'POST',
                url: '/outletstock/importexcel',
                data: {
                    headers: {
                        Authorization: 'Bearer ' + token,
                        "Content-Type": 'multipart/form-data',
                    },
                    data: formData
                }
            });
            if (response.status === 200) {
                setIsAlert(true);
                setTextAlert(response.message);
                setIsImportModalOpen(false);
                getApi("GET", `/outletstock?search=${search}&page=${page.pagination.current}`, 'outletstock');
            } else {
                modalError(response.message);
            }
        } catch (err) {
            console.log(err)
            modalError('Gagal mengunggah file');
        } finally {
            setLoading(false);
        }

        return false; // prevent default antd upload
    };

    return (
        <>
            <Helmet><title>{titlePage}</title></Helmet>
            {isAlert && <Alert message={textAlert} type="success" banner closable afterClose={() => setIsAlert(false)} />}
            <h3>{titlePage}</h3>

            <Row>
                <Col span={8}>
                    <Search placeholder="Cari outlet" allowClear enterButton="Cari" onSearch={setSearch} />
                </Col>
                <Col span={16} style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                    <Button icon={<FileExcelOutlined />} onClick={() => setIsExportModalOpen(true)}>Export Excel</Button>
                    <Button icon={<UploadOutlined />} onClick={() => setIsImportModalOpen(true)}>Import</Button>
                    <Button type="primary" onClick={() => openModal('add', null)}>
                        <PlusOutlined /> Tambah Outlet
                    </Button>
                </Col>
            </Row>
            <Table
                columns={columns}
                dataSource={data}
                rowKey="outlet_id"
                pagination={page.pagination}
                loading={loading}
                onChange={handleTableChange}
            />
            <Modal
                title={dataModal?.mode === 'detail' ? 'Detail Stok Outlet' : dataModal?.mode === 'edit' ? 'Ubah Stok Outlet' : 'Tambah Stok Outlet'}
                open={isModal}
                onCancel={closeModal}
                onOk={dataModal?.mode === 'detail' ? closeModal : form.submit}
                width={800}
            >
                <Form form={form} layout="vertical" onFinish={onFinish}>
                    {dataModal?.mode === 'detail' ? (
                        <>
                            <Descriptions bordered size="small" column={1}>
                                <Descriptions.Item label="Outlet">{dataModal.outlet_name}</Descriptions.Item>
                                <Descriptions.Item label="Kode">{dataModal.outlet_code}</Descriptions.Item>
                                <Descriptions.Item label="Gudang">{dataModal.warehouse_name}</Descriptions.Item>
                            </Descriptions>
                            <Table
                                title={() => 'Detail Stok'}
                                size="small"
                                dataSource={dataModal.outlet_stocks.map((s, idx) => ({ key: idx, ...s }))}
                                pagination={false}
                                columns={[
                                    {
                                        title: 'Varian',
                                        dataIndex: 'variant_product_id',
                                        render: (value) => variantMap[value] || value,
                                    },
                                    { title: 'Stok', dataIndex: 'stock' },
                                    {
                                        title: 'Detail',
                                        render: (_, record) => (
                                            <Button size="small" onClick={() => openStockOutModal(record.outlet_stock_outs)}>Detail Stok Keluar</Button>
                                        ),
                                    },
                                ]}
                            />
                        </>
                    ) : (
                        <>
                            <Form.Item name="outlet_id" label="Outlet" rules={[{ required: true }]}>
                                <Select virtual={false} options={outletOptions} style={{ width: '100%' }} showSearch optionFilterProp="label" />
                            </Form.Item>
                            <Form.List name="product_variant">
                                {(fields, { add, remove }) => (
                                    <>
                                        {fields.map(({ key, name, ...restField }) => (
                                            <Row key={key} gutter={8} align="middle">
                                                <Col span={12}>
                                                    <Form.Item {...restField} name={[name, 'variant_product_id']} label="Varian" rules={[{ required: true }]}>
                                                        <Select virtual={false} options={variantOptions} showSearch optionFilterProp="label" style={{ width: '100%' }} dropdownStyle={{ whiteSpace: 'normal' }} />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={10}>
                                                    <Form.Item {...restField} name={[name, 'stock']} label="Stok" rules={[{ required: true }]}>
                                                        <InputNumber style={{ width: '100%' }} />
                                                    </Form.Item>
                                                </Col>
                                                <Col span={2}>
                                                    <Button danger onClick={() => remove(name)}>Hapus</Button>
                                                </Col>
                                            </Row>
                                        ))}
                                        <Form.Item>
                                            <Button type="dashed" onClick={() => add()} block>+ Tambah Varian</Button>
                                        </Form.Item>
                                    </>
                                )}
                            </Form.List>
                        </>
                    )}
                </Form>
            </Modal>
            <Modal
                title="Stok Keluar Per Tanggal"
                open={stockOutModal}
                onCancel={() => setStockOutModal(false)}
                footer={null}
            >
                <Table
                    size="small"
                    dataSource={stockOutDetail.map((o, i) => ({ key: i, ...o }))}
                    pagination={false}
                    columns={[
                        { title: 'Tanggal', dataIndex: 'date' },
                        { title: 'Jumlah Keluar', dataIndex: 'stock_out' },
                    ]}
                />
            </Modal>
            <Modal
                title="Pilih Tanggal Export"
                open={isExportModalOpen}
                onCancel={() => setIsExportModalOpen(false)}
                onOk={handleExportStockOut}
            >
                <Row gutter={16}>
                    <Col span={12}>
                        <label>Dari Tanggal:</label>
                        <DatePicker value={startDate} onChange={setStartDate} format="YYYY-MM-DD" style={{ width: '100%' }} />
                    </Col>
                    <Col span={12}>
                        <label>Sampai Tanggal:</label>
                        <DatePicker value={endDate} onChange={setEndDate} format="YYYY-MM-DD" style={{ width: '100%' }} />
                    </Col>
                </Row>
            </Modal>
            <Modal
                title="Import Stok Outlet"
                open={isImportModalOpen}
                onCancel={() => setIsImportModalOpen(false)}
                footer={null}
            >
                <p><b>Langkah:</b></p>
                <ol>
                    <li>Download template Excel di bawah</li>
                    <li>Isi data sesuai kolom: <i>Nama Outlet, Produk Variant, Stok Sekarang</i></li>
                    <li>Upload file Excel untuk mengimpor data</li>
                </ol>
                <Row gutter={16}>
                    <Col span={12}>
                        <Button block onClick={handleDownloadTemplate}>Download Template</Button>
                    </Col>
                    <Col span={12}>
                        <Upload
                            beforeUpload={handleImportExcel}
                            showUploadList={false}
                            accept=".xlsx"
                        >
                            <Button block type="primary" icon={<UploadOutlined />}>Upload Excel</Button>
                        </Upload>
                    </Col>
                </Row>
            </Modal>
        </>
    );
}

export default OutletStock;
